import { connect } from "react-redux";

var Modal = require("components/utility/AltModal");
var ErrorDisplay = require("components/utility/ErrorDisplay");

var RosterActions = require("lib/actions/RosterActions");

require("org/contests/invite_teachers_modal.scss");

@connect(
	() => ({}),
	(dispatch, propTypes) => ({
		postReferrals: (referralData) => {
			dispatch(RosterActions.postReferrals({
				referral: referralData
			}))
		}
	})
)

class InviteTeachersModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { emailsText: "" };
		this.modal = React.createRef();
		this.errors = React.createRef();
	}

	onSubmit() {
		this.errors.current.reset();

		var recipients = _.map(this.state.emailsText.split(/[ ,\n]/g), (x) => x.trim());
		var validEmails = _.select(recipients, $wr.isValidEmail);

		if (validEmails.length) {
			this.props.postReferrals({ emails: validEmails });
			this.modal.current.hide()
		} else {
			this.errors.current.setError("Enter at least one valid email.");
		}
	}

	render() {
		return (
			<div className="inviteTeachersModal">
				<Modal ref={ this.modal } selfOpen onHide={ this.props.onClose } headerText="Invite teachers to use Whooo's Reading">
					<div className="modal-body">
						<p>
							Once other teachers at your school sign up, 
							classes will be able to compare progress, work towards a common goal, 
							or set up a friendly competition!
						</p>

						<ErrorDisplay ref={ this.errors } />

						<textarea className="form-control inviteRecipients" rows="2" cols="20"
							placeholder="Enter emails" value={ this.state.emailsText }
							onChange={ (e) => { this.setState({ emailsText: e.target.value }) } } />

						<button className="buttonSuccess center-block" onClick={ this.onSubmit }>
							Send
						</button>

					</div>
				</Modal>
			</div>
		);
	}
};

InviteTeachersModal.WrappedComponent.propTypes = StrictPropTypes({
	// @connect handlers
	postReferrals: PropTypes.func,
	onClose: PropTypes.func
});

module.exports = InviteTeachersModal;


// WEBPACK FOOTER //
// ./modules/components/org/contests/InviteTeachersModal.js